import {
    createAsyncThunk
} from '@reduxjs/toolkit';
import axios from 'axios';
import {
    APIClient,
    api
} from '../../helpers/api_helper';
import Log from '../../Services/Log';
import {
    API_ENDPOINTS
} from '../../constants/apiEndPoints';


export const getCatalogMob = createAsyncThunk('catalogs/getAll', async (_, thunkAPI) => {
    try {
        const response = await api.get(`${API_ENDPOINTS.CATALOGS.GET_ALL}?limit=5&status=all&page=1`);
        console.log('mobCatalog data', response);
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response ?.data || 'Error');
    }
});